import type { ILanguageResources, ITranslationModule } from '../../interfaces';
import { interpolate } from '../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.dealer-franchisee.ApplicationInitialization.';
  public static readonly frameConfigSystemCouldNotBeLoaded = `${Id.prefix}frameConfigSystemCouldNotBeLoaded`;
  public static readonly frameConfigServicesOffline = `${Id.prefix}frameConfigServicesOffline`;
  public static readonly supplier = `${Id.prefix}supplier`;
  public static readonly loading = `${Id.prefix}loading`;
  public static readonly unhandledError = `${Id.prefix}unhandledError`;
  public static readonly unhandledErrorInsidePromise = `${Id.prefix}unhandledErrorInsidePromise`;
  public static readonly supplierTermsCannotBeRetrieved = `${Id.prefix}supplierTermsCannotBeRetrieved`;
  public static readonly loginRefused = `${Id.prefix}loginRefused`;
  public static readonly loginRejected = `${Id.prefix}loginRejected`;
}

export class LangApplicationInitialization {
  private constructor() {}
  public static frameConfigSystemCouldNotBeLoaded(): string {
    return interpolate(Id.frameConfigSystemCouldNotBeLoaded);
  }
  public static frameConfigServicesOffline(): string {
    return interpolate(Id.frameConfigServicesOffline);
  }
  public static supplier(): string {
    return interpolate(Id.supplier);
  }
  public static loading(): string {
    return interpolate(Id.loading);
  }
  public static unhandledError(): string {
    return interpolate(Id.unhandledError);
  }
  public static unhandledErrorInsidePromise(): string {
    return interpolate(Id.unhandledErrorInsidePromise);
  }
  public static supplierTermsCannotBeRetrieved(params: { description: string }): string {
    return interpolate(Id.supplierTermsCannotBeRetrieved, params);
  }
  public static loginRefused(): string {
    return interpolate(Id.loginRefused);
  }
  public static loginRejected(): string {
    return interpolate(Id.loginRejected);
  }
}

export class ApplicationInitializationModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(
      Id.frameConfigSystemCouldNotBeLoaded,
      "The {{glossary 'frame'}} configuration system could not be loaded and the software cannot run. please contact admin if this continues.\nrefreshing page now",
      'Error message when frame config system cannot be loaded'
    );
    register.add(
      Id.frameConfigServicesOffline,
      "{{glossary 'frame'}} configuration services offline",
      'Title for frame config services offline'
    );
    register.add(Id.supplier, "{{glossary 'supplier'}}", 'Glossary for supplier');
    register.add(Id.loading, 'Loading', 'Loading label');
    register.add(Id.unhandledError, 'unhandled error', 'Caption for unhandled error');
    register.add(
      Id.unhandledErrorInsidePromise,
      'Unhandled Error inside a promise occurred',
      'Message for unhandled error inside a promise'
    );
    register.add(
      Id.supplierTermsCannotBeRetrieved,
      "The {{glossary 'supplier'}} ({{description}}) Terms and Conditions cannot be retrieved at this time. Please try refreshing this page. Contact support if no progress is made.",
      'Error message when supplier terms and conditions cannot be retrieved'
    );
    register.add(
      Id.loginRefused,
      'Your login details are valid, but the server refused to accept your login at this time. please try again later.',
      'Message shown when login is refused by the server'
    );
    register.add(Id.loginRejected, 'Login Rejected', 'Dialog title for login rejected');
  }
}
